import React from 'react';
import { useLocation } from "react-router-dom";
import ShowSkyflowImage from '../../common/ShowSkyflowImage';
import { useEffect } from 'react';
import { hideMainLoader } from '../../../utils/commonfunction';

export default function RevealSkyflowImage() {
    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    let props = {
        // table: "users",
        // column: "associate_profile_image",
        // skyflowID: "6e1c88cf-622d-401b-8707-fcf893e78dcc"
    };
    try {
        const data = queryParams.get("data");
        const decryptedData = atob(data);
        props = JSON.parse(decryptedData);
    } catch (err) {
        alert(err.message);
        console.error(err);
    }
    return (
        <ShowSkyflowImage {...props} />
    )
}